import { useMemo, useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { useAuthStore } from "hooks/useAuthStore";
import { TextField, Button, Box, InputAdornment, IconButton } from "@mui/material";
import { Eye, EyeOff } from "react-feather";
import Swal from "sweetalert2";

import image from '../../../assets/img/manvar-login.png';
import './LoginPage.css'


import { useForm } from "hooks/useForm";
import { AuthLayout } from "../layout/AuthLayout";

import { CustomLoading } from "../../../common";


const loginFormFields = {
    loginEmail: '',
    loginPassword: ''
}

export const LoginPage = () => {
    const { startLogin, errorMessage } = useAuthStore()
    const { status, loadingLogin } = useSelector(state => state.auth)
    const [showPassword, setShowPassword] = useState(false)

    const isAuthenticating = useMemo(() => status === 'checking', [status])

    const { loginEmail, loginPassword, onInputChange: onInputChangeLogin } = useForm(loginFormFields)

    const navigate = useNavigate();

    const loginSubmit = (e) => {
        e.preventDefault()

        // Recupera cual fue el ultimo path visitado
        const lastPath = localStorage.getItem('lastPath') || '/';

        // Inicia sesión
        startLogin({ email: loginEmail, password: loginPassword })

        // lleva al usuario a la última pantalla visitada
        navigate( lastPath, {
            replace: true
        });
    }

    useEffect(() => {
        if (errorMessage !== undefined) {
            Swal.fire('Error en la autenticacion', errorMessage, 'error')
        }
    }, [errorMessage])

    return (
        <AuthLayout logo={image}>
            <Box component="form" className="login-form" onSubmit={loginSubmit}>
                <h1 className="login-form__title">Iniciar sesión</h1>
                <p className="login-form__subtitle">
                    Ingresa tus credenciales para continuar
                </p>

                <Box className="login-form__fields">
                    <TextField
                        label="Correo"
                        type="email"
                        placeholder="correo@example.com"
                        fullWidth
                        name="loginEmail"
                        value={loginEmail}
                        onChange={onInputChangeLogin}
                        autoComplete="username"
                    />

                    <TextField
                        id="loginPassword"
                        name="loginPassword"
                        label="Contraseña"
                        fullWidth
                        type={showPassword ? "text" : "password"}
                        value={loginPassword}
                        onChange={onInputChangeLogin}
                        autoComplete="current-password"
                        InputProps={{
                            endAdornment: (
                                <InputAdornment position="end">
                                    <IconButton
                                        type="button"
                                        aria-label={
                                        showPassword
                                            ? "Ocultar contraseña"
                                            : "Mostrar contraseña"
                                        }
                                        onClick={() => setShowPassword((current) => !current)}
                                        edge="end"
                                    >
                                        {showPassword ? <EyeOff size={20} /> : <Eye size={20} />}
                                    </IconButton>
                                </InputAdornment>
                            ),
                        }}
                    />
                </Box>

                {loadingLogin && <CustomLoading />}

                <Button
                    className="login-form__submit"
                    disabled={isAuthenticating}
                    type="submit"
                    variant="contained"
                    fullWidth
                    sx={{ backgroundColor: "#354860" }}
                >
                    Iniciar sesión
                </Button>
            </Box>
        </AuthLayout>
    )

}